import errorHandler from "./errorHandler"

/**
 * Gets two dates and returns the difference in days.
 * If the endDate is undefined, we use today instead.
 * @returns number: days of difference between two dates.
 */
export const dateDiff = (
  startDate: string | any,
  endDate: string | any | undefined = undefined
): number => {
  try {
    const start = new Date(startDate)
    const end = endDate ? new Date(endDate) : new Date()
    const diffTime = Math.abs(+end - +start)
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
    return diffDays
  } catch (e) {
    errorHandler(e)
    return 0
  }
}
